import { ListView } from '@syncfusion/ej2-lists';
import { Button, CheckBox } from '@syncfusion/ej2-buttons';
import { createElement, L10n, isNullOrUndefined } from '@syncfusion/ej2-base';
import { ContentControl, ContentControlListItems } from '../viewer/page';
import { ColorPicker, TextBox } from '@syncfusion/ej2-inputs';
export class ContentControlPropertiesDialog {
    /**
     * @param {DocumentHelper} documentHelper - Specifies the document helper.
     * @private
     */
    constructor(documentHelper) {
        this.colorPicker = undefined;
        this.fontColor = undefined;
        this.keyUpOnTextBoxClickHandler = this.onKeyUpOnTextBoxClicked.bind(this);
        this.setButtonClickHandler = this.onSetButtonClick.bind(this);
        this.clearButtonClickHandler = this.onClearButtonClick.bind(this);
        /**
         * @private
         */
        this.characterFormat = undefined;
        this.clearButtonClick = (args) => {
            this.textBoxInput.value = '';
            this.valueBoxInput.value = '';
            for (let i = 0; i < this.convertedItems.length; i++) {
                if (this.convertedItems[parseInt(i.toString(), 10)].value === this.currentSelectedItem) {
                    this.currentContentControl.contentControlProperties.contentControlListItems.splice(i, 1);
                    this.convertedItems.splice(i, 1);
                }
            }
            this.listviewInstance.dataSource = this.convertedItems.slice();
            this.listviewInstance.dataBind();
        };
        /* eslint-disable  */
        this.setButtonClick = (args) => {
            if (!isNullOrUndefined(this.textBoxInput.value) ||
                !isNullOrUndefined(this.valueBoxInput.value)) {
                const newItem = new ContentControlListItems();
                newItem.displayText = this.textBoxInput.value ? this.textBoxInput.value : '';
                newItem.value = this.valueBoxInput.value ? this.valueBoxInput.value : '';
                this.currentContentControl.contentControlProperties.contentControlListItems.push(newItem);
                const convertedItem = {
                    displayText: newItem.displayText,
                    value: newItem.value
                };
                this.convertedItems.push(convertedItem);
                this.listviewInstance.addItem([convertedItem]);
            }
            this.textBoxInput.value = '';
            this.valueBoxInput.value = '';
        };
        /**
         * @private
         * @returns {void}
         */
        this.onKeyUpOnTextBox = () => {
            this.enableOrDisableButton();
        };
        this.loadPropertiesdialog = () => {
            this.currentContentControl = this.documentHelper.owner.selection.currentContentControl;
            if (!isNullOrUndefined(this.currentContentControl)) {
                this.contentEditedCheckBox.checked = this.currentContentControl.contentControlProperties.lockContents;
                this.contentDeletedCheckBox.checked = this.currentContentControl.contentControlProperties.lockContentControl;
                this.removeCheckBox.checked = this.currentContentControl.contentControlProperties.isTemporary;
                this.multilineCheckBox.checked = this.currentContentControl.contentControlProperties.multiline;
                this.colorPicker.value = this.currentContentControl.contentControlProperties.color;
                if (this.removeCheckBox.checked) {
                    this.contentEditedCheckBox.checked = false;
                }
                this.titleText.value = this.currentContentControl.contentControlProperties.title ? this.currentContentControl.contentControlProperties.title : '';
                this.tagText.value = this.currentContentControl.contentControlProperties.tag ? this.currentContentControl.contentControlProperties.tag : '';
                this.fontColor = this.currentContentControl.contentControlProperties.color;
                if (this.currentContentControl.contentControlProperties.type === 'Text') {
                    this.plainTextPropertiesDiv.style.display = 'block';
                }
                else {
                    this.plainTextPropertiesDiv.style.display = 'none';
                }
                if (this.currentContentControl.contentControlProperties.type === 'ComboBox' || this.currentContentControl.contentControlProperties.type === 'DropDownList') {
                    this.dropDownPropertiesDiv.style.display = 'block';
                }
                else {
                    this.dropDownPropertiesDiv.style.display = 'none';
                }
                if (!isNullOrUndefined(this.currentContentControl.contentControlProperties.contentControlListItems !== undefined)) {
                    this.convertedItems = this.currentContentControl.contentControlProperties.contentControlListItems.map(item => {
                        const convertedItem = {};
                        for (const prop in item) {
                            convertedItem[`${prop}`] = item[`${prop}`];
                        }
                        return convertedItem;
                    });
                    this.listviewInstance.dataSource = this.convertedItems;
                    this.listviewInstance.dataBind();
                }
            }
            this.documentHelper.updateFocus();
        };
        this.applyProperties = () => {
            let start = this.documentHelper.selection.start.clone();
            let end = this.documentHelper.selection.end.clone();
            let offset = this.currentContentControl.line.getOffset(this.currentContentControl, 1);
            this.documentHelper.selection.start.setPositionParagraph(this.currentContentControl.line, offset);
            this.documentHelper.selection.end.setPositionParagraph(this.currentContentControl.line, offset + 1);
            this.documentHelper.owner.editorModule.initHistory('UpdateContentControl');
            const properties = this.documentHelper.owner.editor.getContentControlPropObject(this.currentContentControl.contentControlProperties);
            if (!isNullOrUndefined(this.fontColor)) {
                this.currentContentControl.contentControlProperties.color = this.fontColor;
            }
            let contentControlImage = this.documentHelper.owner.getImageContentControl();
            if ((contentControlImage instanceof ContentControl && contentControlImage.contentControlProperties.type == 'Picture')) {
                contentControlImage.contentControlProperties.lockContents = this.contentEditedCheckBox.checked;
                contentControlImage.contentControlProperties.lockContentControl = this.contentDeletedCheckBox.checked;
                contentControlImage.contentControlProperties.isTemporary = this.removeCheckBox.checked;
                if (this.removeCheckBox.checked) {
                    contentControlImage.contentControlProperties.lockContents = false;
                }
                contentControlImage.contentControlProperties.title = this.titleText.value !== undefined ? this.titleText.value : '';
                contentControlImage.contentControlProperties.tag = this.tagText.value !== undefined ? this.tagText.value : '';
                contentControlImage.contentControlProperties.multiline = this.multilineCheckBox.checked;
            }
            if (!isNullOrUndefined(this.currentContentControl)) {
                this.currentContentControl.contentControlProperties.lockContents = this.contentEditedCheckBox.checked;
                this.currentContentControl.contentControlProperties.lockContentControl = this.contentDeletedCheckBox.checked;
                this.currentContentControl.contentControlProperties.isTemporary = this.removeCheckBox.checked;
                if (this.removeCheckBox.checked) {
                    this.currentContentControl.contentControlProperties.lockContents = false;
                }
                this.currentContentControl.contentControlProperties.title = this.titleText.value !== undefined ? this.titleText.value : '';
                this.currentContentControl.contentControlProperties.tag = this.tagText.value !== undefined ? this.tagText.value : '';
                this.currentContentControl.contentControlProperties.multiline = this.multilineCheckBox.checked;
            }
            if (this.documentHelper.owner.editorHistoryModule) {
                if (this.documentHelper.owner.editorHistoryModule.currentBaseHistoryInfo) {
                    this.documentHelper.owner.editorHistoryModule.currentBaseHistoryInfo.modifiedProperties.push(properties);
                    const format = this.documentHelper.owner.editor.getContentControlPropObject(this.currentContentControl.contentControlProperties);
                    this.documentHelper.owner.editorHistoryModule.currentBaseHistoryInfo.format = JSON.stringify(format);
                }
                this.documentHelper.owner.editorHistoryModule.updateHistory();
            }
            this.documentHelper.selection.selectRange(start, end);
            this.unWireEventsAndBindings();
            this.documentHelper.dialog.hide();
            this.documentHelper.viewer.updateScrollBars();
            this.documentHelper.updateFocus();
            this.documentHelper.owner.editorModule.fireContentChange();
        };
        this.closePropertiesDialog = () => {
            this.documentHelper.dialog.hide();
            this.unWireEventsAndBindings();
            this.documentHelper.updateFocus();
        };
        this.fontColorUpdate = (args) => {
            if (!isNullOrUndefined(args.currentValue)) {
                this.fontColor = args.currentValue.hex;
            }
        };
        /**
         * @private
         * @param args args value.
         * @returns {void}
         */
        /* eslint-disable  */
        this.selectHandler = (args) => {
            this.currentSelectedItem = args.text;
        };
        this.documentHelper = documentHelper;
    }
    getModuleName() {
        return 'ContentControlPropertiesDialog';
    }
    createInputElement(type, id, className) {
        const element = createElement('input', {
            attrs: { type: type },
            id: id,
            className: className
        });
        return element;
    }
    initContentControlPropertiesDialog(localeValue, enableRtl) {
        this.target = createElement('div', { className: 'e-de-cont-cntr' });
        this.container = createElement('div');
        this.generalDiv = createElement('div');
        this.genLabel = createElement('div', { className: 'e-de-para-dlg-heading', innerHTML: localeValue.getConstant('General') });
        this.generalDiv.appendChild(this.genLabel);
        this.displayText = createElement('div', { className: 'e-de-dlg-container' });
        this.titleText = createElement('input', { className: 'e-input' });
        this.displayText.appendChild(this.titleText);
        this.generalDiv.appendChild(this.displayText);
        this.tagText = createElement('input', { className: 'e-input' });
        this.generalDiv.appendChild(this.tagText);
        this.colorDiv = createElement('div', { className: 'e-de-container-row' });
        this.colorDiv.style.paddingTop = '10px';
        this.fontColorDiv = createElement('div', { className: 'e-de-font-dlg-display' });
        this.fontColorLabel = createElement('label', {
            className: 'e-de-font-dlg-header-font-color e-de-font-color-margin',
            innerHTML: localeValue.getConstant('Color')
        });
        // if (isRtl) {
        //     fontColorLabel.classList.add('e-de-rtl');
        // }
        this.fontColorDiv.appendChild(this.fontColorLabel);
        this.fontColorElement = this.createInputElement('color', this.target.id + '_ColorDiv', 'e-de-font-dlg-color');
        this.fontColorDiv.appendChild(this.fontColorElement);
        this.colorDiv.appendChild(this.fontColorDiv);
        this.generalDiv.appendChild(this.colorDiv);
        const { columns, createPopupOnClick, cssClass, disabled, enablePersistence, inline, mode, modeSwitcher, noColor, presetColors, showButtons } = this.documentHelper.owner.documentEditorSettings.colorPickerSettings;
        this.colorPicker = new ColorPicker({
            change: this.fontColorUpdate, value: '#000000', locale: this.documentHelper.owner.locale, enableOpacity: false, mode: mode, modeSwitcher: modeSwitcher, showButtons: showButtons, columns: columns, createPopupOnClick: createPopupOnClick, cssClass: cssClass, disabled: disabled, enablePersistence: enablePersistence, inline: inline, noColor: noColor, presetColors: presetColors
        });
        this.colorPicker.appendTo(this.fontColorElement);
        this.style = createElement('div', { styles: 'display:block' });
        this.generalDiv.appendChild(this.style);
        this.remove = createElement('div', { styles: 'display:block' });
        this.generalDiv.appendChild(this.remove);
        this.removeContent = createElement('input', {
            attrs: { type: 'checkbox' }
        });
        this.remove.appendChild(this.removeContent);
        this.removeCheckBox = new CheckBox({
            label: localeValue.getConstant('Remove content control when contents are edited'),
            cssClass: 'e-de-para-dlg-cs-check-box'
        });
        this.removeCheckBox.appendTo(this.removeContent);
        this.removeContent.setAttribute('aria-label', localeValue.getConstant('Remove content control when contents are edited'));
        this.container.appendChild(this.generalDiv);
        this.lockedDiv = createElement('div');
        this.lockedDiv.style.paddingTop = '10px';
        this.lockedLabel = createElement('div', { className: 'e-de-para-dlg-heading', innerHTML: localeValue.getConstant('Locking') });
        this.lockedDiv.appendChild(this.lockedLabel);
        this.contentDelete = createElement('div', { styles: 'display:block' });
        this.lockedDiv.appendChild(this.contentDelete);
        this.contentDeleted = createElement('input', {
            attrs: { type: 'checkbox' }
        });
        this.contentDelete.appendChild(this.contentDeleted);
        this.contentDeletedCheckBox = new CheckBox({
            label: localeValue.getConstant('Content control cannot be deleted'),
            cssClass: 'e-de-para-dlg-cs-check-box',
            change: (args) => {
                if (args.checked) {
                    this.removeCheckBox.disabled = true;
                    this.removeCheckBox.dataBind();
                }
                else {
                    this.removeCheckBox.disabled = false;
                    this.removeCheckBox.dataBind();
                }
            }
        });
        this.contentDeletedCheckBox.appendTo(this.contentDeleted);
        this.contentDeleted.setAttribute('aria-label', localeValue.getConstant('Content control cannot be deleted'));
        this.contentEdit = createElement('div', { styles: 'display:block' });
        this.lockedDiv.appendChild(this.contentEdit);
        this.contentEdited = createElement('input', {
            attrs: { type: 'checkbox' }
        });
        this.contentEdit.appendChild(this.contentEdited);
        this.contentEditedCheckBox = new CheckBox({
            label: localeValue.getConstant('Contents cannot be edited'),
            cssClass: 'e-de-para-dlg-cs-check-box'
        });
        this.contentEditedCheckBox.appendTo(this.contentEdited);
        this.contentEdited.setAttribute('aria-label', localeValue.getConstant('Contents cannot be edited'));
        this.container.appendChild(this.lockedDiv);
        this.plainTextPropertiesDiv = createElement('div');
        this.plainTextPropertiesDiv.style.marginTop = '10px';
        this.plainTextPropertiesDiv.style.display = 'none';
        this.plainTextLabel = createElement('div', { className: 'e-de-para-dlg-heading', innerHTML: localeValue.getConstant('Plain Text properties') });
        this.plainTextPropertiesDiv.appendChild(this.plainTextLabel);
        this.multiline = createElement('input', {
            attrs: { type: 'checkbox' }
        });
        this.plainTextPropertiesDiv.appendChild(this.multiline);
        this.multilineCheckBox = new CheckBox({
            label: localeValue.getConstant('Allow carriage returns'),
            //enableRtl: isRtl,
            cssClass: 'e-de-para-dlg-cs-check-box'
        });
        this.multilineCheckBox.appendTo(this.multiline);
        this.multiline.setAttribute('aria-label', localeValue.getConstant('Allow carriage returns'));
        this.container.appendChild(this.plainTextPropertiesDiv);
        this.dropDownPropertiesDiv = createElement('div');
        this.dropDownPropertiesDiv.style.marginTop = '10px';
        this.dropDownPropertiesDiv.style.display = 'none';
        this.lockedcontentLabel = createElement('div', { className: 'e-de-para-dlg-heading', innerHTML: localeValue.getConstant('Drop_Down List properties') });
        this.dropDownPropertiesDiv.appendChild(this.lockedcontentLabel);
        this.commonDiv = createElement('div', { className: 'e-bookmark-common' });
        this.dropDownPropertiesDiv.appendChild(this.commonDiv);
        this.searchDiv = createElement('div', { className: 'e-bookmark-list' });
        this.commonDiv.appendChild(this.searchDiv);
        this.textBoxDiv = createElement('div', { className: 'e-bookmark-textboxdiv' });
        this.searchDiv.appendChild(this.textBoxDiv);
        this.textBoxInput = createElement('input', { className: 'e-input e-bookmark-textbox-input', id: 'bookmark_text_box' });
        this.textBoxInput.setAttribute('type', 'text');
        this.textBoxInput.addEventListener('keyup', this.keyUpOnTextBoxClickHandler);
        this.textBoxInput.setAttribute('aria-label', localeValue.getConstant('Display Text'));
        this.textBoxDiv.appendChild(this.textBoxInput);
        this.valueBoxDiv = createElement('div', { className: 'e-bookmark-textboxdiv' });
        this.searchDiv.appendChild(this.valueBoxDiv);
        this.valueBoxInput = createElement('input', { className: 'e-input e-bookmark-textbox-input', id: 'bookmark_text_box' });
        this.valueBoxInput.setAttribute('type', 'text');
        this.valueBoxInput.addEventListener('keyup', this.keyUpOnTextBoxClickHandler);
        this.valueBoxInput.setAttribute('aria-label', localeValue.getConstant('Value'));
        this.valueBoxDiv.appendChild(this.valueBoxInput);
        this.listviewDiv = createElement('div', { className: 'e-bookmark-listViewDiv', id: 'bookmark_listview', attrs: { tabindex: '-1', role: 'listbox' } });
        this.searchDiv.appendChild(this.listviewDiv);
        this.listviewInstance = new ListView({
            cssClass: 'e-bookmark-listview',
            select: this.selectHandler,
            fields: { text: 'value' }
        });
        this.listviewInstance.appendTo(this.listviewDiv);
        this.buttonDiv = createElement('div', { className: 'e-bookmark-button' });
        this.commonDiv.appendChild(this.buttonDiv);
        this.addbuttonDiv = createElement('div', { className: 'e-bookmark-addbutton' });
        this.buttonDiv.appendChild(this.addbuttonDiv);
        this.addButtonElement = createElement('button', {
            innerHTML: localeValue.getConstant('Add'), id: 'add',
            attrs: { type: 'button' }
        });
        this.addButtonElement.setAttribute('aria-label', localeValue.getConstant('Add'));
        this.addbuttonDiv.appendChild(this.addButtonElement);
        this.addButton = new Button({ cssClass: 'e-button-custom' });
        this.addButton.disabled = true;
        this.addButton.appendTo(this.addButtonElement);
        //addButtonElement.addEventListener('click', this.setButtonClick);
        this.addButtonElement.addEventListener('click', this.setButtonClickHandler);
        this.deleteButtonDiv = createElement('div', { className: 'e-bookmark-deletebutton' });
        this.buttonDiv.appendChild(this.deleteButtonDiv);
        this.deleteButtonElement = createElement('button', {
            innerHTML: localeValue.getConstant('Delete'), id: 'delete',
            attrs: { type: 'button' }
        });
        this.deleteButtonElement.setAttribute('aria-label', localeValue.getConstant('Delete'));
        this.deleteButtonDiv.appendChild(this.deleteButtonElement);
        this.deleteButton = new Button({ cssClass: 'e-button-custom' });
        this.deleteButton.appendTo(this.deleteButtonElement);
        this.deleteButtonElement.addEventListener('click', this.clearButtonClickHandler);
        this.container.appendChild(this.dropDownPropertiesDiv);
        this.target.appendChild(this.container);
        new TextBox({ placeholder: localeValue.getConstant('Title'), floatLabelType: 'Always' }, this.titleText);
        new TextBox({ placeholder: localeValue.getConstant('Tag'), floatLabelType: 'Always' }, this.tagText);
        new TextBox({ placeholder: localeValue.getConstant('Display Text'), floatLabelType: 'Always' }, this.textBoxInput);
        new TextBox({ placeholder: localeValue.getConstant('Value'), floatLabelType: 'Always' }, this.valueBoxInput);
    }
    /**
     * @private
     * @returns {void}
     */
    show() {
        const localValue = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
        localValue.setLocale(this.documentHelper.owner.locale);
        this.localeValue = localValue;
        if (!this.target) {
            this.initContentControlPropertiesDialog(localValue, false);
        }
        if (this.documentHelper.selection.caret.style.display !== 'none') {
            this.documentHelper.selection.caret.style.display = 'none';
        }
        if (this.dropDownPropertiesDiv.style.display !== 'none' || this.plainTextPropertiesDiv.style.display !== 'none') {
            this.dropDownPropertiesDiv.style.display = 'none';
            this.plainTextPropertiesDiv.style.display = 'none';
        }
        this.documentHelper.dialog.header = localValue.getConstant('Content Control Properties');
        this.documentHelper.dialog.height = 'auto';
        this.documentHelper.dialog.width = 'auto';
        this.documentHelper.dialog.beforeOpen = this.loadPropertiesdialog;
        this.documentHelper.dialog.content = this.target;
        this.documentHelper.dialog.buttons = [
            {
                click: this.applyProperties,
                buttonModel: { content: this.localeValue.getConstant('Ok'), cssClass: 'e-flat e-para-okay', isPrimary: true }
            },
            {
                click: this.closePropertiesDialog,
                buttonModel: { content: this.localeValue.getConstant('Cancel'), cssClass: 'e-flat e-para-cancel' }
            }
        ];
        this.documentHelper.dialog.close = this.documentHelper.updateFocus;
        this.documentHelper.dialog.dataBind();
        this.documentHelper.dialog.show();
    }
    /* eslint-disable  */
    onClearButtonClick(args) {
        this.clearButtonClick(args);
    }
    onSetButtonClick(args) {
        this.setButtonClick(args);
    }
    onKeyUpOnTextBoxClicked() {
        this.onKeyUpOnTextBox();
    }
    enableOrDisableButton() {
        if (!isNullOrUndefined(this.addButton)) {
            this.addButton.disabled = this.textBoxInput.value === '' || this.valueBoxInput.value === '';
        }
    }
    unWireEventsAndBindings() {
        this.fontColor = undefined;
        this.currentContentControl = undefined;
        this.currentSelectedItem = undefined;
        this.convertedItems = [];
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.contentDeletedCheckBox) {
            this.contentDeletedCheckBox.destroy();
            this.contentDeletedCheckBox = undefined;
        }
        if (this.contentEditedCheckBox) {
            this.contentEditedCheckBox.destroy();
            this.contentEditedCheckBox = undefined;
        }
        if (this.removeCheckBox) {
            this.removeCheckBox.destroy();
            this.removeCheckBox = undefined;
        }
        if (this.multilineCheckBox) {
            this.multilineCheckBox.destroy();
            this.multilineCheckBox = undefined;
        }
        if (this.listviewInstance) {
            this.listviewInstance.destroy();
            this.listviewInstance = undefined;
        }
        if (this.textBoxInput) {
            this.textBoxInput.remove();
            this.textBoxInput = undefined;
        }
        if (this.valueBoxInput) {
            this.valueBoxInput.remove();
            this.valueBoxInput = undefined;
        }
        if (this.titleText) {
            this.titleText.remove();
            this.titleText = undefined;
        }
        if (this.tagText) {
            this.tagText.remove();
            this.tagText = undefined;
        }
        if (this.colorPicker) {
            this.colorPicker.destroy();
        }
        this.colorPicker = undefined;
        this.documentHelper = undefined;
        this.removeEvents();
        this.removeElements();
        if (!isNullOrUndefined(this.target)) {
            if (this.target.parentElement) {
                this.target.parentElement.removeChild(this.target);
            }
            for (let i = 0; i < this.target.childNodes.length; i++) {
                this.target.removeChild(this.target.childNodes[parseInt(i.toString(), 10)]);
                i--;
            }
            this.target = undefined;
        }
    }
    removeEvents() {
        if (this.addButtonElement) {
            this.addButtonElement.removeEventListener('click', this.setButtonClickHandler);
        }
        if (this.deleteButtonElement) {
            this.deleteButtonElement.removeEventListener('click', this.clearButtonClickHandler);
        }
        if (this.textBoxInput) {
            this.textBoxInput.removeEventListener('keyup', this.keyUpOnTextBoxClickHandler);
        }
        if (this.valueBoxInput) {
            this.valueBoxInput.removeEventListener('keyup', this.keyUpOnTextBoxClickHandler);
        }
    }
    removeElements() {
        if (this.generalDiv) {
            this.generalDiv.remove();
            this.generalDiv = undefined;
        }
        if (this.genLabel) {
            this.genLabel.remove();
            this.genLabel = undefined;
        }
        if (this.displayText) {
            this.displayText.remove();
            this.displayText = undefined;
        }
        if (this.colorDiv) {
            this.colorDiv.remove();
            this.colorDiv = undefined;
        }
        if (this.fontColorDiv) {
            this.fontColorDiv.remove();
            this.fontColorDiv = undefined;
        }
        if (this.fontColorLabel) {
            this.fontColorLabel.remove();
            this.fontColorLabel = undefined;
        }
        if (this.fontColorElement) {
            this.fontColorElement.remove();
            this.fontColorElement = undefined;
        }
        if (this.style) {
            this.style.remove();
            this.style = undefined;
        }
        if (this.remove) {
            this.remove.remove();
            this.remove = undefined;
        }
        if (this.removeContent) {
            this.removeContent.remove();
            this.removeContent = undefined;
        }
        if (this.lockedDiv) {
            this.lockedDiv.remove();
            this.lockedDiv = undefined;
        }
        if (this.lockedLabel) {
            this.lockedLabel.remove();
            this.lockedLabel = undefined;
        }
        if (this.contentDelete) {
            this.contentDelete.remove();
            this.contentDelete = undefined;
        }
        if (this.contentDeleted) {
            this.contentDeleted.remove();
            this.contentDeleted = undefined;
        }
        if (this.contentEdit) {
            this.contentEdit.remove();
            this.contentEdit = undefined;
        }
        if (this.contentEdited) {
            this.contentEdited.remove();
            this.contentEdited = undefined;
        }
        if (this.plainTextLabel) {
            this.plainTextLabel.remove();
            this.plainTextLabel = undefined;
        }
        if (this.multiline) {
            this.multiline.remove();
            this.multiline = undefined;
        }
        if (this.lockedcontentLabel) {
            this.lockedcontentLabel.remove();
            this.lockedcontentLabel = undefined;
        }
        if (this.commonDiv) {
            this.commonDiv.remove();
            this.commonDiv = undefined;
        }
        if (this.searchDiv) {
            this.searchDiv.remove();
            this.searchDiv = undefined;
        }
        if (this.textBoxDiv) {
            this.textBoxDiv.remove();
            this.textBoxDiv = undefined;
        }
        if (this.valueBoxDiv) {
            this.valueBoxDiv.remove();
            this.valueBoxDiv = undefined;
        }
        if (this.listviewDiv) {
            this.listviewDiv.remove();
            this.listviewDiv = undefined;
        }
        if (this.buttonDiv) {
            this.buttonDiv.remove();
            this.buttonDiv = undefined;
        }
        if (this.addbuttonDiv) {
            this.addbuttonDiv.remove();
            this.addbuttonDiv = undefined;
        }
        if (this.addButtonElement) {
            this.addButtonElement.remove();
            this.addButtonElement = undefined;
        }
        if (this.deleteButtonDiv) {
            this.deleteButtonDiv.remove();
            this.deleteButtonDiv = undefined;
        }
        if (this.deleteButtonElement) {
            this.deleteButtonElement.remove();
            this.deleteButtonElement = undefined;
        }
    }
}
